module.exports = __webpack_public_path__ + "img/LeftBreadcrumb.b0f67a63.png";